import {
  CopySettings,
  localStorageCopySettings,
  WebflowStyleGuide,
} from 'base/copy_settings';
import { action } from 'mobx';
import { Project, ProjectState } from './editor/model';

export const getProjectWebflowStyleGuide = (
  project: Project | ProjectState,
): WebflowStyleGuide =>
  project.webflowStyle ?? localStorageCopySettings.value.style;

export const setProjectWebflowStyleGuide = action(
  (project: Project, style: WebflowStyleGuide) => {
    project.webflowStyle = style;
  },
);

export const getProjectCopySettings = (
  project: Project | ProjectState,
): CopySettings => {
  return {
    ...localStorageCopySettings.value,
    style: getProjectWebflowStyleGuide(project),
  };
};

export const setProjectCopySettings = action(
  (project: Project, settings: CopySettings) => {
    project.webflowStyle = settings.style;
    // Update everything other than the style, since we already updated it on the
    // project.
    localStorageCopySettings.set({
      ...settings,
      style: localStorageCopySettings.value.style,
    });
  },
);
